const BirthTimeMask = () => {
  const birthTimeInput = document.querySelector("input#birth-time");

  if (birthTimeInput) {
    birthTimeInput.addEventListener("input", (event) => {
      let value = event.target.value;

      value = value.replace(/[^0-9]/g, '');

      if (value.length > 4) {
        value = value.slice(0, 4);
      }

      if (value.length >= 2) {
        const hours = value.slice(0, 2);
        if (parseInt(hours, 10) > 12) {
          value = '12' + value.slice(2);
        }
      }

      if (value.length > 2) {
        const minutes = value.slice(2, 4);
        if (parseInt(minutes, 10) > 59) {
          value = value.slice(0, 2) + '59';
        }
      }

      if (value.length > 2) {
        value = value.slice(0, 2) + ':' + value.slice(2);
      }

      event.target.value = value;
    });
  }
};

export default BirthTimeMask;
